import React from "react";
import {
  Box,
  VStack,
  HStack,
  Text,
  Button,
  Heading,
  Alert,
  AlertIcon,
  Spinner,
  Center,
  Icon
} from "@chakra-ui/react";
import { Link } from "react-router-dom";
import { useUser } from "@gadgetinc/react";
import { api } from "../api";

export default function AdminAgentChat() {
  const user = useUser();

  // Check if user has system-admin role
  const isSystemAdmin = user?.roles?.some(role => 
    typeof role === 'string' ? role === 'system-admin' : role?.key === 'system-admin' || role?.name === 'system-admin'
  );

  // Handle access control
  if (!user) {
    return (
      <Center h="100vh">
        <Spinner size="xl" />
      </Center>
    );
  }

  if (!isSystemAdmin) {
    return (
      <Box p={8} maxW="600px" mx="auto" mt={16}>
        <Alert status="error" borderRadius="md">
          <AlertIcon />
          <VStack align="start" spacing={2}>
            <Text fontWeight="bold">Access Denied</Text>
            <Text>You do not have permission to access this page. System administrator access is required.</Text>
          </VStack>
        </Alert>
        <Box mt={4}>
          <Button as={Link} to="/admin" colorScheme="blue" variant="outline">
            Return to Admin Panel
          </Button>
        </Box>
      </Box>
    );
  }

  return (
    <Box p={8} maxW="800px" mx="auto" mt={8} bg="gray.900" minH="100vh">
      <VStack spacing={8} align="center">
        {/* Header */}
        <VStack spacing={4} align="center">
          <Heading size="xl" color="white" textAlign="center">
            Agent Testing Has Moved
          </Heading>
          <Text fontSize="lg" color="gray.300" textAlign="center" maxW="600px">
            The agent chat interface has been moved to our new and improved agents system.
          </Text>
        </VStack>

        {/* Info Box */}
        <Box
          p={8}
          bg="gray.800"
          borderRadius="lg"
          border="2px solid"
          borderColor="blue.500"
          maxW="600px"
          w="full"
        >
          <VStack spacing={6} align="center">
            <Icon viewBox="0 0 24 24" boxSize={12} color="blue.400">
              <path
                fill="currentColor"
                d="M12 2C13.1 2 14 2.9 14 4C14 5.1 13.1 6 12 6C10.9 6 10 5.1 10 4C10 2.9 10.9 2 12 2ZM21 9V7L15 1H9C7.9 1 7 1.9 7 3V9C7 10.1 7.9 11 9 11V12C9 13.1 9.9 14 11 14H13C14.1 14 15 13.1 15 12V11C16.1 11 17 10.1 17 9V7H21V9H19V11C19 12.1 19.9 13 21 13H23V15H21C18.8 15 17 13.2 17 11V9H15V12C15 14.2 13.2 16 11 16H13C14.1 16 15 16.9 15 18V22H13V18H11V22H9V18C9 16.9 9.9 16 11 16H9C6.8 16 5 14.2 5 12V9H3V7H7V3C7 1.9 7.9 1 9 1H3V3H1V1C1 .4 1.4 0 2 0H22C22.6 0 23 .4 23 1V3H21V1Z"
              />
            </Icon>
            
            <VStack spacing={4} align="center">
              <Heading size="md" color="white">
                Enhanced Agent Experience
              </Heading>
              <Text color="gray.300" textAlign="center">
                Our new agents system provides improved performance, better conversation management, 
                and enhanced features for testing and interacting with AI agents.
              </Text>
            </VStack>

            {/* Navigation Buttons */}
            <VStack spacing={4} w="full">
              <Button
                as={Link}
                to="/agents"
                colorScheme="blue"
                size="lg"
                w="full"
                py={6}
              >
                Go to New Agents System
              </Button>
              
              <Button
                as={Link}
                to="/admin"
                variant="outline"
                colorScheme="gray"
                size="lg"
                w="full"
                py={6}
              >
                Back to Admin Panel
              </Button>
            </VStack>
          </VStack>
        </Box>
      </VStack>
    </Box>
  );
}